<template>
  <section id="PreferredLanguage">
    <div class="form-group pb-lg-3 pl-lg-4">
      <label>{{ $t('Language') }}</label>
      <Select2 
        v-model="language" 
        :options="languageOptions" 
        :settings="languageOptionsSettings" 
        @select="selectLang($event)"
      />
    </div>
  </section>
</template>
<script>
import Select2 from "v-select2-component";

import {
    localSave,
    localRead
} from "@/store/lang";
import { computed } from "vue-simple-suggest";
import languages from "@/plugins/static/language.json";


export default {
    components: {
        Select2,
    },
    data() {
        return {
            language: localRead("local"),
            localList: languages,
            languageOptionsSettings: {
                minimumResultsForSearch: Infinity,
                placeholder: "Select target duration...",
                templateResult: this.select2Options,
                templateSelection: this.select2Selections,
            },
        };
    },
    computed: {
      languageOptions() {
        if (!this.localList) {
          return [];
        }
        return this.localList.map((item, index) => ({
          id: item.code,
          ...item,
          name: this.$t(item.name),
        }))
      }
    },
    methods: {
      selectLang(options) {
        localSave("local", options.id);
        location.reload();
      },
      select2Options: function (data) {
        if (!data.id) {
          return data.name;
        }
        let newStateText = $(`<div class="d-flex align-items-center">${data.name}</div>`);
        return newStateText;
      },
      select2Selections: function (data) {
        return data.name;
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/profile/PreferredLanguage.vue